import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext.js';
import PrivateRoute from './components/common/PrivateRoute.js';
import ProtectedLayout from './components/common/ProtectedLayout.js';

// Auth Pages
import Login from './components/auth/Login.js';
import ForgotPassword from './components/auth/ForgotPassword.js';
import ResetPassword from './components/auth/ResetPassword.js';

// Home Pages
import LandingPage from './components/home/LandingPage.js';
import PublicShipmentTracking from './components/home/PublicShipmentTracking.js';
import UserShipmentTracking from './components/home/UserShipmentTracking.js';
import PublicViewReturn from './components/home/PublicViewReturn.js';
import ContactUs from './components/home/ContactUs.js';
import Features from './components/home/Features.js';
import About from './components/home/About.js';
import Services from './components/home/Services.js';

// Dashboard Pages
import AdminDashboard from './components/dashboard/AdminDashboard.js';
import AccountantDashboard from './components/dashboard/AccountantDashboard.js';
import AgentDashboard from './components/dashboard/AgentDashboard.js';

// User Pages
import UserList from './components/user/UserList.js';
import AddUser from './components/user/AddUser.js';
import EditUser from './components/user/EditUser.js';
import ViewUser from './components/user/ViewUser.js';

// Role Pages
import RoleList from './components/role/RoleList.js';
import AddRole from './components/role/AddRole.js';
import EditRole from './components/role/EditRole.js';
import ViewRole from './components/role/ViewRole.js';

// Vehicle Pages
import VehicleList from './components/vehicle/VehicleList.js';
import AddVehicle from './components/vehicle/AddVehicle.js';
import EditVehicle from './components/vehicle/EditVehicle.js';
import ViewVehicle from './components/vehicle/ViewVehicle.js';

// Vehicle Owner Pages
import VehicleOwnerList from './components/vehicle-owner/VehicleOwnerList.js';
import AddVehicleOwner from './components/vehicle-owner/AddVehicleOwner.js';
import EditVehicleOwner from './components/vehicle-owner/EditVehicleOwner.js';
import ViewVehicleOwner from './components/vehicle-owner/ViewVehicleOwner.js';

// Contact Pages
import ContactList from './components/contact/ContactList.js';
import EditContact from './components/contact/EditContact.js';
import ViewContact from './components/contact/ViewContact.js';

// Testimonial Pages
import TestimonialList from './components/testimonial/TestimonialList.js';
import AddTestimonial from './components/testimonial/AddTestimonial.js';
import EditTestimonial from './components/testimonial/EditTestimonial.js';
import ViewTestimonial from './components/testimonial/ViewTestimonial.js';

// Payment Pages
import PaymentList from './components/payment/PaymentList.js';
import AddPayment from './components/payment/AddPayment.js';
import EditPayment from './components/payment/EditPayment.js';
import ViewPayment from './components/payment/ViewPayment.js';
import DailyEarnings from './components/payment/DailyEarnings.js';

// Shipment Client Pages
import ShipmentClientList from './components/shipment-client/ShipmentClientList.js';
import AddShipmentClient from './components/shipment-client/AddShipmentClient.js';
import EditShipmentClient from './components/shipment-client/EditShipmentClient.js';
import ViewShipmentClient from './components/shipment-client/ViewShipmentClient.js';
import VendorBatchShipmentBill from './components/shipment-client/VendorBatchShipmentBill.js';

// Shipment Pages
import ShipmentList from './components/shipment/ShipmentList.js';
import AddShipment from './components/shipment/AddShipment.js';
import EditShipment from './components/shipment/EditShipment.js';
import ViewShipment from './components/shipment/ViewShipment.js';

// Shipment Return Pages
import ReturnList from './components/shipment-return/ReturnList.js';
import AddReturn from './components/shipment-return/AddReturn.js';
import EditReturn from './components/shipment-return/EditReturn.js';
import ViewReturn from './components/shipment-return/ViewReturn.js';

// Location Hub Pages
import LocationHubList from "./components/location-hub/LocationHubList.js"
import AddLocationHub from "./components/location-hub/AddLocationHub.js"
import EditLocationHub from "./components/location-hub/EditLocationHub.js"
import ViewLocationHub from "./components/location-hub/ViewLocationHub.js"

// Shipment Missing Pages
import MissingList from "./components/shipment-missing/MissingList.js"
import AddMissing from "./components/shipment-missing/AddMissing.js"
import EditMissing from "./components/shipment-missing/EditMissing.js"
import ViewMissing from "./components/shipment-missing/ViewMissing.js"

// ML Sheet Pages
import MLSheetList from "./components/ml-sheet/MLSheetList.js"
import AddMLSheet from "./components/ml-sheet/AddMLSheet.js"
import EditMLSheet from "./components/ml-sheet/EditMLSheet.js"
import ViewMLSheet from "./components/ml-sheet/ViewMLSheet.js"
import StatusUpdate from "./components/ml-sheet/StatusUpdate.js"

// External Entity Pages
import ExternalMLList from "./components/external-entity/ExternalMLList.js"
import ViewExternalML from "./components/external-entity/ViewExternalML.js"
import ViewExternalShipment from "./components/external-entity/ViewExternalShipment.js"

// On Contract Pages
import OnContractList from "./components/on_contracts/OnContractList"
import AddOnContract from "./components/on_contracts/AddOnContract"
import EditOnContract from "./components/on_contracts/EditOnContract"
import ViewOnContract from "./components/on_contracts/ViewOnContract"

// Salary Pages
import SalaryList from './components/salary/SalaryList.js';
import AddSalary from './components/salary/AddSalary.js';
import EditSalary from './components/salary/EditSalary.js';
import ViewSalary from './components/salary/ViewSalary.js';

// Loan Given Routes
import LoanGivenList from './components/loan-given/LoanGivenList.js';
import AddLoanGiven from './components/loan-given/AddLoanGiven.js';
import EditLoanGiven from './components/loan-given/EditLoanGiven.js';
import ViewLoanGiven from './components/loan-given/ViewLoanGiven.js';
import AddRepaymentGiven from './components/loan-given/AddRepaymentGiven.js';

// Loan Received Routes
import LoanReceivedList from './components/loan-received/LoanReceivedList.js';
import AddLoanReceived from './components/loan-received/AddLoanReceived.js';
import EditLoanReceived from './components/loan-received/EditLoanReceived.js';
import ViewLoanReceived from './components/loan-received/ViewLoanReceived.js';
import AddRepaymentReceived from './components/loan-received/AddRepaymentReceived.js';

// Analytics Routes
import Analytics from './components/analytics/Analytics.js';
import ShipmentAnalytics from './components/analytics/ShipmentAnalytics.js';
import UserPerformanceAnalytics from './components/analytics/UserPerformanceAnalytics.js';
import VehicleAnalytics from './components/analytics/VehicleAnalytics.js';
import MissingReturnedAnalytics from './components/analytics/MissingReturnedAnalytics.js';
import ProfitLossAnalytics from './components/analytics/ProfitLossAnalytics.js';
import InventoryAnalytics from './components/analytics/InventoryAnalytics.js';
import CommissionAnalytics from './components/analytics/CommissionAnalytics.js';

// Report Routes
import Reports from './components/report/Reports.js';

// Attendance Pages
import AttendanceList from './components/attendance/AttendanceList.js';
import ViewAttendance from './components/attendance/ViewAttendance.js';
import ViewAttendanceReport from './components/attendance/ViewAttendanceReport.js';
import EditAttendance from './components/attendance/EditAttendance.js';

// Expense Pages
import ExpenseList from './components/expense/ExpenseList.js';
import AddExpense from './components/expense/AddExpense.js';
import EditExpense from './components/expense/EditExpense.js';
import ViewExpense from './components/expense/ViewExpense.js';

// Inventory Pages
import InventoryList from './components/inventory/InventoryList.js';
import AddInventory from './components/inventory/AddInventory.js';
import EditInventory from './components/inventory/EditInventory.js';
import ViewInventory from './components/inventory/ViewInventory.js';

// Inventory Usage Pages
import AddInventoryUsage from './components/inventory-usage/AddInventoryUsage.js';
import EditInventoryUsage from './components/inventory-usage/EditInventoryUsage.js';
import ViewInventoryUsage from './components/inventory-usage/ViewInventoryUsage.js';

// Inventory SKU Pages
import AddInventorySKU from './components/inventory-sku/AddInventorySKU.js';
import EditInventorySKU from './components/inventory-sku/EditInventorySKU.js';
import ViewInventorySKU from './components/inventory-sku/ViewInventorySKU.js';

// Shipment Commission Pages
import CommissionList from './components/shipment-commission/CommissionList.js';
import AddCommission from './components/shipment-commission/AddCommission.js';
import EditCommission from './components/shipment-commission/EditCommission.js';
import ViewCommission from './components/shipment-commission/ViewCommission.js';
import CommissionDashboard from './components/shipment-commission/CommissionDashboard.js';
import HubInsights from './components/shipment-commission/HubInsights.js';

// Scroll to top page
import { BrowserRouter } from "react-router-dom";
import ScrollToTop from "./components/common/ScrollToTop";

function App() {
  return (
    <Router>
      <ScrollToTop />
      <AuthProvider>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<LandingPage />} />
          <Route path="/features" element={<Features />} />
          <Route path="/contact-us" element={<ContactUs />} />
          <Route path="/about" element={<About />} />
          <Route path="/services" element={<Services />} />
          <Route path="/public-track-shipment" element={<PublicShipmentTracking />} />
          <Route path="/public-view-return/:returnId" element={<PublicViewReturn />} />

          {/* Authentication Routes */}
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password" element={<ResetPassword />} />

          {/* Authenticated routes — Header & Sidebar stay mounted (no reload on navigation) */}
          <Route element={<ProtectedLayout />}>
          {/* Internal Tracking Route (Authenticated Users) */}
          <Route
            path="/track-shipment"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant', 'Agent']} element={<UserShipmentTracking />} />}
          />

          {/* Admin Dashboard */}
          <Route
            path="/admin-dashboard"
            element={<PrivateRoute roles={['System Admin', 'Admin']} element={<AdminDashboard />} />}
          />

          {/* Accountant Dashboard */}
          <Route
            path="/accountant-dashboard"
            element={<PrivateRoute roles={['Accountant']} element={<AccountantDashboard />} />}
          />

          {/* Agent Dashboard */}
          <Route
            path="/agent-dashboard"
            element={<PrivateRoute roles={['Agent']} element={<AgentDashboard />} />}
          />

          {/* User Management Routes */}
          <Route
            path="/users"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant', 'Agent']} element={<UserList />} />}
          />
          <Route
            path="/users/add"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<AddUser />} />}
          />
          <Route
            path="/users/edit/:userId"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<EditUser />} />}
          />
          <Route
            path="/users/view/:userId"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant', 'Agent']} element={<ViewUser />} />}
          />

          {/* Role Management Routes */}
          <Route
            path="/roles"
            element={<PrivateRoute roles={['System Admin']} element={<RoleList />} />}
          />
          <Route
            path="/roles/add"
            element={<PrivateRoute roles={['System Admin']} element={<AddRole />} />}
          />
          <Route
            path="/roles/edit/:roleId"
            element={<PrivateRoute roles={['System Admin']} element={<EditRole />} />}
          />
          <Route
            path="/roles/view/:roleId"
            element={<PrivateRoute roles={['System Admin']} element={<ViewRole />} />}
          />

          {/* Vehicle Management Routes */}
          <Route
            path="/vehicles"
            element={<PrivateRoute roles={['System Admin', 'Admin']} element={<VehicleList />} />}
          />
          <Route
            path="/vehicles/add"
            element={<PrivateRoute roles={['System Admin', 'Admin']} element={<AddVehicle />} />}
          />
          <Route
            path="/vehicles/view/:vehicleId"
            element={<PrivateRoute roles={['System Admin', 'Admin']} element={<ViewVehicle />} />}
          />
          <Route
            path="/vehicles/edit/:vehicleId"
            element={<PrivateRoute roles={['System Admin', 'Admin']} element={<EditVehicle />} />}
          />

          {/* Vehicle Owner Management Routes */}
          <Route
            path="/vehicle-owners"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<VehicleOwnerList />} />}
          />
          <Route
            path="/vehicle-owners/add"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<AddVehicleOwner />} />}
          />
          <Route
            path="/vehicle-owners/edit/:ownerId"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<EditVehicleOwner />} />}
          />
          <Route
            path="/vehicle-owners/view/:ownerId"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant', 'Agent']} element={<ViewVehicleOwner />} />}
          />

          {/* Contact Management Routes - ADMIN */}
          <Route
            path="/contact"
            element={<PrivateRoute roles={['System Admin', 'Admin']} element={<ContactList />} />}
          />
          <Route
            path="/contact/view/:contactId"
            element={<PrivateRoute roles={['System Admin', 'Admin']} element={<ViewContact />} />}
          />
          <Route
            path="/contact/edit/:contactId"
            element={<PrivateRoute roles={['System Admin', 'Admin']} element={<EditContact />} />}
          />

          {/* Testimonial Management Routes */}
          <Route
            path="/testimonials"
            element={<PrivateRoute roles={['System Admin', 'Admin']} element={<TestimonialList />} />}
          />
          <Route
            path="/testimonials/add"
            element={<PrivateRoute roles={['System Admin', 'Admin']} element={<AddTestimonial />} />}
          />
          <Route
            path="/testimonials/edit/:testimonialId"
            element={<PrivateRoute roles={['System Admin', 'Admin']} element={<EditTestimonial />} />}
          />
          <Route
            path="/testimonials/view/:testimonialId"
            element={<PrivateRoute roles={['System Admin', 'Admin']} element={<ViewTestimonial />} />}
          />

          {/* Attendance Management Routes */}
          <Route
            path="/attendance"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant', 'Agent']} element={<AttendanceList />} />}
          />
          <Route
            path="/attendance/view/:attendanceId"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<ViewAttendance />} />}
          />
          <Route
            path="/attendance/report/:userId"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant', 'Agent']} element={<ViewAttendanceReport />} />}
          />
          <Route
            path="/attendance/edit/:attendanceId"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<EditAttendance />} />}
          />

          {/* Shipment Client Management Routes */}
          <Route
            path="/shipment-clients"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant', 'Agent']} element={<ShipmentClientList />} />}
          />
          <Route
            path="/shipment-clients/add"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<AddShipmentClient />} />}
          />
          <Route
            path="/shipment-clients/edit/:clientId"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<EditShipmentClient />} />}
          />
          <Route
            path="/shipment-clients/view/:clientId"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant', 'Agent']} element={<ViewShipmentClient />} />}
          />
          <Route
            path="/shipment-clients/batch-bill/:clientId"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<VendorBatchShipmentBill />} />}
          />

          {/* Payment Management Routes */}
          <Route
            path="/payment-history"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant', 'Agent']} element={<PaymentList />} />}
          />
          <Route
            path="/payment-history/add/:shipmentId"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant', 'Agent']} element={<AddPayment />} />}
          />
          <Route
            path="/payment-history/edit/:paymentId"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant', 'Agent']} element={<EditPayment />} />}
          />
          <Route
            path="/payment-history/view/:paymentId"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant', 'Agent']} element={<ViewPayment />} />}
          />
          <Route
            path="/daily-earnings"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant', 'Agent']} element={<DailyEarnings />} />}
          />

          {/* Shipment Management Routes */}
          <Route
            path="/shipments"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant', 'Agent']} element={<ShipmentList />} />}
          />
          <Route
            path="/shipments/add"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant', 'Agent']} element={<AddShipment />} />}
          />
          <Route
            path="/shipments/edit/:shipmentId"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<EditShipment />} />}
          />
          <Route
            path="/shipments/view/:shipmentId"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant', 'Agent']} element={<ViewShipment />} />}
          />

          {/* Return Management Routes - UPDATED */}
          {/* All authenticated users can view list and create returns */}
          <Route
            path="/returns"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant', 'Agent']} element={<ReturnList />} />}
          />
          <Route
            path="/returns/add"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant', 'Agent']} element={<AddReturn />} />}
          />
          <Route
            path="/returns/view/:returnId"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant', 'Agent']} element={<ViewReturn />} />}
          />
          {/* Only Admin, System Admin, Accountant can approve/reject */}
          <Route
            path="/returns/edit/:returnId"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<EditReturn />} />}
          />

          {/* Location Hub Management Routes - ADMIN ONLY */}
          <Route
            path="/location-hubs"
            element={<PrivateRoute roles={["System Admin", "Admin"]} element={<LocationHubList />} />}
          />
          <Route
            path="/location-hubs/add"
            element={<PrivateRoute roles={["System Admin", "Admin"]} element={<AddLocationHub />} />}
          />
          <Route
            path="/location-hubs/edit/:hubId"
            element={<PrivateRoute roles={["System Admin", "Admin"]} element={<EditLocationHub />} />}
          />
          <Route
            path="/location-hubs/view/:hubId"
            element={<PrivateRoute roles={["System Admin", "Admin"]} element={<ViewLocationHub />} />}
          />

          {/* Salary Management Routes - ADMIN & ACCOUNTANT */}
          <Route
            path="/salaries"
            element={
              <PrivateRoute roles={["System Admin", "Admin", "Accountant", "Agent"]} element={<SalaryList />} />
            }
          />
          <Route
            path="/salaries/add"
            element={<PrivateRoute roles={["System Admin", "Admin", "Accountant"]} element={<AddSalary />} />}
          />
          <Route
            path="/salaries/edit/:salaryId"
            element={<PrivateRoute roles={["System Admin", "Admin", "Accountant"]} element={<EditSalary />} />}
          />
          <Route
            path="/salaries/view/:salaryId"
            element={
              <PrivateRoute roles={["System Admin", "Admin", "Accountant", "Agent"]} element={<ViewSalary />} />
            }
          />

          {/* ML Sheet Management Routes */}
          <Route
            path="/ml-sheets"
            element={<PrivateRoute element={<MLSheetList />} />}
          />
          <Route
            path="/ml-sheets/add"
            element={<PrivateRoute roles={["System Admin", "Admin", "Accountant", "Agent"]} element={<AddMLSheet />} />}
          />
          <Route
            path="/ml-sheets/edit/:mlSheetId"
            element={<PrivateRoute roles={["System Admin", "Admin", "Accountant", "Agent"]} element={<EditMLSheet />} />}
          />
          <Route
            path="/ml-sheets/view/:mlSheetId"
            element={<PrivateRoute element={<ViewMLSheet />} />}
          />
          <Route
            path="/ml-sheets/view/:mlSheetId/status-update"
            element={
              <PrivateRoute roles={["System Admin", "Admin", "Accountant", "Agent"]} element={<StatusUpdate />} />
            }
          />

          {/* External Entity Management Routes */}
          <Route
            path="/external-ml"
            element={
              <PrivateRoute roles={["System Admin", "Admin", "Accountant", "Agent"]} element={<ExternalMLList />} />
            }
          />
          <Route
            path="/external-ml/view/:externalMLId"
            element={
              <PrivateRoute roles={["System Admin", "Admin", "Accountant", "Agent"]} element={<ViewExternalML />} />
            }
          />
          <Route
            path="/external-ml/:externalMLId/shipment/:shipmentId"
            element={
              <PrivateRoute roles={["System Admin", "Admin", "Accountant", "Agent"]} element={<ViewExternalShipment />} />
            }
          />

          {/* On Contract Routes */}
          <Route
            path="/on-contracts"
            element={
              <PrivateRoute roles={["System Admin", "Admin", "Accountant"]} element={<OnContractList />} />
            }
          />
          <Route
            path="/on-contracts/add"
            element={
              <PrivateRoute roles={["System Admin", "Admin", "Accountant"]} element={<AddOnContract />} />
            }
          />
          <Route
            path="/on-contracts/edit/:contractId"
            element={
              <PrivateRoute roles={["System Admin", "Admin", "Accountant"]} element={<EditOnContract />} />
            }
          />
          <Route
            path="/on-contracts/view/:contractId"
            element={
              <PrivateRoute roles={["System Admin", "Admin", "Accountant"]} element={<ViewOnContract />} />
            }
          />

          {/* Missing Shipment Management Routes - ALL AUTHENTICATED USERS */}
          <Route
            path="/missing"
            element={
              <PrivateRoute roles={["System Admin", "Admin", "Accountant", "Agent"]} element={<MissingList />} />
            }
          />
          <Route
            path="/missing/add"
            element={<PrivateRoute roles={["System Admin", "Admin", "Accountant", "Agent"]} element={<AddMissing />} />}
          />
          <Route
            path="/missing/edit/:missingId"
            element={
              <PrivateRoute roles={["System Admin", "Admin", "Accountant", "Agent"]} element={<EditMissing />} />
            }
          />
          <Route
            path="/missing/view/:missingId"
            element={
              <PrivateRoute roles={["System Admin", "Admin", "Accountant", "Agent"]} element={<ViewMissing />} />
            }
          />

          {/* Loan Given Management Routes */}
          <Route
            path="/loans-given"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<LoanGivenList />} />}
          />
          <Route
            path="/loans-given/add"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<AddLoanGiven />} />}
          />
          <Route
            path="/loans-given/edit/:loanId"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<EditLoanGiven />} />}
          />
          <Route
            path="/loans-given/view/:loanId"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<ViewLoanGiven />} />}
          />
          <Route
            path="/loans-given/repayment/:loanId"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<AddRepaymentGiven />} />}
          />

          {/* Loan Received Management Routes */}
          <Route
            path="/loans-received"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<LoanReceivedList />} />}
          />
          <Route
            path="/loans-received/add"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<AddLoanReceived />} />}
          />
          <Route
            path="/loans-received/edit/:loanId"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<EditLoanReceived />} />}
          />
          <Route
            path="/loans-received/view/:loanId"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<ViewLoanReceived />} />}
          />
          <Route
            path="/loans-received/repayment/:loanId"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<AddRepaymentReceived />} />}
          />

          {/* Analytics Routes */}
          <Route
            path="/analytics"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<Analytics />} />}
          />
          <Route
            path="/analytics/shipments"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<ShipmentAnalytics />} />}
          />
          <Route
            path="/analytics/user-performance"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<UserPerformanceAnalytics />} />}
          />
          <Route
            path="/analytics/vehicles"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<VehicleAnalytics />} />}
          />
          <Route
            path="/analytics/missing-returned"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<MissingReturnedAnalytics />} />}
          />
          <Route
            path="/analytics/profit-loss"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<ProfitLossAnalytics />} />}
          />
          <Route
            path="/analytics/inventory"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<InventoryAnalytics />} />}
          />
          <Route
            path="/analytics/commission"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<CommissionAnalytics />} />}
          />

          {/* Reports Routes */}
          <Route
            path="/reports"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<Reports />} />}
          />

          {/* Expense Management Routes */}
          <Route
            path="/expenses"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<ExpenseList />} />}
          />
          <Route
            path="/expenses/add"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<AddExpense />} />}
          />
          <Route
            path="/expenses/edit/:expenseId"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<EditExpense />} />}
          />
          <Route
            path="/expenses/view/:expenseId"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<ViewExpense />} />}
          />

          {/* Inventory Management Routes */}
          <Route
            path="/inventory"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<InventoryList />} />}
          />
          <Route
            path="/inventory/add"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<AddInventory />} />}
          />
          <Route
            path="/inventory/edit/:inventoryId"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<EditInventory />} />}
          />
          <Route
            path="/inventory/view/:inventoryId"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<ViewInventory />} />}
          />

          {/* Inventory Usage Management Routes */}
          <Route
            path="/inventory-usage/add/:inventoryId"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<AddInventoryUsage />} />}
          />
          <Route
            path="/inventory-usage/edit/:usageId"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<EditInventoryUsage />} />}
          />
          <Route
            path="/inventory-usage/view/:usageId"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<ViewInventoryUsage />} />}
          />

          {/* Inventory SKU Management Routes */}
          <Route
            path="/inventory-sku/add/:inventoryId"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<AddInventorySKU />} />}
          />
          <Route
            path="/inventory-sku/edit/:skuId"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<EditInventorySKU />} />}
          />
          <Route
            path="/inventory-sku/view/:skuId"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<ViewInventorySKU />} />}
          />

          {/* Commission Management Routes */}
          <Route
            path="/commissions"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<CommissionList />} />}
          />
          <Route
            path="/commissions/add"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<AddCommission />} />}
          />
          <Route
            path="/commissions/edit/:commissionId"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<EditCommission />} />}
          />
          <Route
            path="/commissions/view/:commissionId"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<ViewCommission />} />}
          />
          <Route
            path="/commissions/add-payment/:commissionId"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<ViewCommission />} />}
          />
          <Route
            path="/commission-dashboard"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<CommissionDashboard />} />}
          />
          <Route
            path="/commissions/hub-insights"
            element={<PrivateRoute roles={['System Admin', 'Admin', 'Accountant']} element={<HubInsights />} />}
          />

          </Route>

          {/* Catch all - redirect to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </Router>
  );
}

export default App;
